import { Routes } from '@angular/router';
import { HomeLayout } from '@layout/home-layout/home-layout';

import { adminGuard, authGuard, permissionGuard, publicGuard } from '@core/guards';
import { UserPermission } from '@core/interfaces/userPermission.interface';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    pathMatch: 'full',
    canActivate: [publicGuard],
    loadComponent: () => import('@modules/login/pages').then((m) => m.Login)
  },
  // {
  //   path: 'signup',
  //   pathMatch: 'full',
  //   canActivate: [publicGuard],
  //   loadComponent: () => import('@modules/signup/pages').then((m) => m.Signup)
  // },
  {
    path: '',
    component: HomeLayout,
    canActivate: [authGuard],
    children: [
      {
        path: 'dashboard',
        pathMatch: 'full',
        canActivate: [permissionGuard],
        data: { permission: UserPermission.DASHBOARD },
        loadComponent: () => import('@modules/dashboard/pages').then((m) => m.Dashboard)
      },
      {
        path: 'buy-data-bundles',
        pathMatch: 'full',
        canActivate: [permissionGuard],
        data: { permission: UserPermission.BUY_DATA_BUNDLES },
        loadComponent: () => import('@modules/buy-data-bundles/pages').then((m) => m.BuyDataBundles)
      },
      {
        path: 'topup',
        pathMatch: 'full',
        canActivate: [permissionGuard],
        data: { permission: UserPermission.TOPUP },
        loadComponent: () => import('@modules/topup/pages').then((m) => m.Topup)
      },
      {
        path: 'gling-gring-recharge',
        pathMatch: 'full',
        canActivate: [permissionGuard],
        data: { permission: UserPermission.GLING_GRING_RECHARGE },
        loadComponent: () =>
          import('@modules/gling-gring-recharge/pages').then((m) => m.GlingGringRecharge)
      },
      {
        path: 'scheduled-subscriptions',
        pathMatch: 'full',
        canActivate: [permissionGuard],
        data: { permission: UserPermission.SCHEDULED_SUBSCRIPTION },
        loadComponent: () =>
          import('@modules/scheduled-subscriptions/pages').then((m) => m.ScheduledSubscriptions)
      },
      {
        path: 'history',
        pathMatch: 'full',
        canActivate: [permissionGuard],
        data: { permission: UserPermission.HISTORY },
        loadComponent: () => import('@modules/history/pages').then((m) => m.History)
      },
      {
        path: 'activity-logs',
        pathMatch: 'full',
        canActivate: [adminGuard],
        loadComponent: () => import('@modules/activity-logs/pages').then((m) => m.ActivityLogs)
      },
      {
        path: 'reseller',
        pathMatch: 'full',
        canActivate: [adminGuard, permissionGuard],
        data: { permission: UserPermission.RESELLER },
        loadComponent: () => import('@modules/reseller/pages').then((m) => m.Reseller)
      },
      {
        path: 'thai-esims',
        pathMatch: 'full',
        canActivate: [permissionGuard],
        data: { permission: UserPermission.THAI_ESIM },
        loadComponent: () => import('@modules/thai-esims/pages').then((m) => m.ThaiEsims)
      },
      {
        path: 'package',
        pathMatch: 'full',
        canActivate: [permissionGuard],
        data: { permission: UserPermission.PACKAGE },
        loadComponent: () => import('@modules/package/pages').then((m) => m.Package)
      },
      {
        path: 'settings',
        pathMatch: 'full',
        canActivate: [permissionGuard],
        data: { permission: UserPermission.SETTINGS },
        loadComponent: () => import('@modules/settings/pages').then((m) => m.Settings)
      }
    ]
  },
  {
    path: 'cart',
    pathMatch: 'full',
    loadComponent: () => import('@modules/pending-cart/pages').then((m) => m.PendingCart)
  },
  {
    path: 'subscription',
    pathMatch: 'full',
    loadComponent: () =>
      import('@modules/teck-subscriptions/pages').then((m) => m.TeckSubscriptions)
  },
  {
    path: '**',
    redirectTo: 'login'
  }
];
